/* eslint-disable max-len */
export const CollectionsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 4H10L12 6H21C21.5523 6 22 6.44772 22 7V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V5C2 4.44772 2.44772 4 3 4ZM20 8H11.17L9.17 6H4V18H20V8Z"
      fill="#1e4878"
    />
    <path
      d="M13.5 15V16.2071L14.3536 15.3536L16 13.7071L17.6464 15.3536L18.5 16.2071V15V5C18.5 4.17157 17.8284 3.5 17 3.5H15C14.1716 3.5 13.5 4.17157 13.5 5V15Z"
      fill="#1e4878"
    />
  </svg>
);
